import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const revenueAnalyticsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRevenueAnalytics: builder.query<
      CommonResponseType & { data: any },
      void
    >({
      query: () => {
        return {
          url: `${END_POINTS.getRevenueAnalytics}`,
          method: "GET",
        };
      },
    }),
    usersGraph: builder.query<
      CommonResponseType & { data: any },
      { type: string }
    >({
      query: ({ type }) => {
        return {
          url: `${END_POINTS.usersGraph}?type=${type}`,
          method: "GET",
        };
      },
    }),
    productsGraph: builder.query<
      CommonResponseType & { data: any },
      { type: string }
    >({
      query: ({ type }) => {
        return {
          url: `${END_POINTS.productsGraph}?type=${type}`,
          method: "GET",
        };
      },
    }),
    revenueGraph: builder.query<
      CommonResponseType & { data: any },
      { type: string }
    >({
      query: ({ type }) => {
        return {
          url: `${END_POINTS.revenueGraph}?type=${type}`,
          method: "GET",
        };
      },
    }),
    productReportsGraph: builder.query<
      CommonResponseType & { data: any },
      { id: string; type: string }
    >({
      query: ({ id, type }) => {
        return {
          url: `${END_POINTS.productReportsGraph}/${id}?type=${type}`,
          method: "GET",
        };
      },
    }),
    productViewsGraph: builder.query<
      CommonResponseType & { data: any },
      { id: string; type: string }
    >({
      query: ({ id, type }) => {
        return {
          url: `${END_POINTS.productViewsGraph}/${id}?type=${type}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useLazyGetRevenueAnalyticsQuery,
  useLazyUsersGraphQuery,
  useLazyProductsGraphQuery,
  useLazyRevenueGraphQuery,
  useLazyProductReportsGraphQuery,
  useLazyProductViewsGraphQuery,
} = revenueAnalyticsApi;
